export default [{
  title: 'header.document',
  router: '/document/0',
  isApp: true,
  menuCode: '001',
  icon: 'h-icon-menu'
},
{
  title: 'header.document',
  router: '/download',
  isApp: true,
  menuCode: '002',
  icon: 'h-icon-menu'
},
{
  title: 'header.abilityInfo',
  router: '/abilityInfo',
  isApp: true,
  menuCode: '003',
  icon: 'h-icon-menu'
},
{
  title: 'header.abilityDetail',
  router: '/abilityDetail',
  isApp: true,
  menuCode: '004',
  icon: 'h-icon-menu'
}

]
